import DesktopHeader from './Desktop/DesktopHeader';
import MobileHeader from './Mobile/MobileHeader';

export type Theme = 'dark' | 'light';
const Header = ({ theme }: { theme: Theme }) => {
  return (
    <>
      <DesktopHeader theme={theme} />
      <MobileHeader theme={theme} />
    </>
  );
};

export default Header;
